const GET_ANALYSE_RESPONSE = {
  Analyse: 'Analyse',
  TokenError: 'TokenError',
};

export default GET_ANALYSE_RESPONSE;
